module.exports = __webpack_public_path__ + "img/video.0b23f29e.png";